/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Languagerequirementsen_Placeholder3Inputs */

const en_job_form_languagerequirementsen_placeholder3 = /** @type {(inputs: Job_Form_Languagerequirementsen_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. B2 - Upper Intermediate`)
};

const de_job_form_languagerequirementsen_placeholder3 = /** @type {(inputs: Job_Form_Languagerequirementsen_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. B2 - Selbständige Sprachverwendung`)
};

/**
* | output |
* | --- |
* | "e.g. B2 - Upper Intermediate" |
*
* @param {Job_Form_Languagerequirementsen_Placeholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_languagerequirementsen_placeholder3 = /** @type {((inputs?: Job_Form_Languagerequirementsen_Placeholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Languagerequirementsen_Placeholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_languagerequirementsen_placeholder3(inputs)
	return en_job_form_languagerequirementsen_placeholder3(inputs)
});
export { job_form_languagerequirementsen_placeholder3 as "job_form_languageRequirementsEN_placeholder" }